import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../data/content";

export default function AuthorBio() {
    return (
        <section
            id="author"
            data-testid="author-section"
            className="relative py-24 sm:py-36 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                    className="lg:col-span-5 relative"
                >
                    <div className="relative">
                        <div
                            className="absolute -inset-6 blur-2xl opacity-50"
                            style={{
                                background:
                                    "radial-gradient(circle, rgba(122,0,0,0.4), transparent 65%)",
                            }}
                        />
                        <img
                            src={ASSETS.viktor}
                            alt="Viktor Varek"
                            className="relative w-full aspect-[4/5] object-cover object-[60%_25%] grayscale-[20%] contrast-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#030303] via-transparent to-transparent" />
                        <div className="absolute bottom-6 left-6 right-6 font-serif-display italic text-neutral-300 text-sm leading-tight border-l-2 border-[#7A0000] pl-4">
                            “I was prey. I taught myself to stop being seen as
                            such. The Code is what I would have paid anything
                            to read at twenty-two.”
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{
                        duration: 1,
                        delay: 0.2,
                        ease: [0.16, 1, 0.3, 1],
                    }}
                    className="lg:col-span-7"
                >
                    <div className="overline mb-5">The Author</div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#f4f4f0]">
                        Viktor Varek.
                        <br />
                        <span className="italic text-neutral-500">
                            A man who lived the hard version.
                        </span>
                    </h2>
                    <div className="mt-8 space-y-5 text-neutral-300 text-base sm:text-lg leading-relaxed max-w-2xl">
                        <p>
                            He doesn’t do interviews. He doesn’t do podcasts.
                            What you will not find online is a story that
                            includes years inside environments where weakness
                            was punished in silence, and where the wrong frame
                            cost more than money.
                        </p>
                        <p>
                            The Varek Code is the private record of how he
                            stopped being a man people happened{" "}
                            <span className="italic">to</span>, and became a
                            man people accounted{" "}
                            <span className="italic">for</span>.
                        </p>
                        <p className="text-neutral-500 italic font-serif-display text-xl">
                            “Power isn’t loud. Power doesn’t explain itself. It
                            simply changes the temperature of the room.”
                        </p>
                    </div>
                    <div className="mt-10 grid grid-cols-3 gap-6 border-t border-white/5 pt-8 max-w-md">
                        <div>
                            <div className="font-serif-display text-3xl text-[#990000]">
                                12y
                            </div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mt-1">
                                In study
                            </div>
                        </div>
                        <div>
                            <div className="font-serif-display text-3xl text-[#990000]">
                                05
                            </div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mt-1">
                                Phases
                            </div>
                        </div>
                        <div>
                            <div className="font-serif-display text-3xl text-[#990000]">
                                01
                            </div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mt-1">
                                Doctrine
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
